module.exports = __webpack_public_path__ + "img/workflowByStatus.b819826c.png";